// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as TimerComponent} from './Timer.svg';

import Icon, { TIconProps } from '../Icon';

export const IconTimer = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <TimerComponent/>
  </Icon>
));
